import SiteWisePreparation from "@/pages/dashboard/SiteWisePreparation";
import LandfillRates from '@/pages/dashboard/landfill/LandfillRates';
import LandfillTipsites from '@/pages/dashboard/landfill/LandfillTipsites';
import TruckingJobFormPage from "@/pages/dashboard/TruckingJobFormPage";
import { SecureEntryScreen } from "@/components/SecureWorkspaceEntry";
import TruckingWorkspace from "@/components/TruckingWorkspace";
import TruckingOverview from "@/pages/dashboard/TruckingOverview";
import TruckingJobs, { TruckingJobDetail } from "@/pages/dashboard/TruckingJobs";
import TruckingReadyToBill from "@/pages/dashboard/TruckingReadyToBill";
import TruckingReports from "@/pages/dashboard/TruckingReports";
import TruckingReconciliation from "@/pages/dashboard/TruckingReconciliation";
import PublicSiteAudit from '@/pages/PublicSiteAudit';
import HealthSafetyWorkspace from "@/components/HealthSafetyWorkspace";
import LandfillWorkspace from "@/components/LandfillWorkspace";
import { LandfillOverview, LandfillLoads, LandfillTrucks, LandfillCompanies, LandfillInvoices } from "@/pages/dashboard/landfill/Landfill";
import DriverIntake from "@/pages/public/DriverIntake";
import HealthSafetyOverview from "@/pages/dashboard/HealthSafetyOverview";
import HazardsRisks from "@/pages/dashboard/HazardsRisks";
import AssignedForm from "@/pages/dashboard/AssignedForm";
import { useEffect, useLayoutEffect, useRef } from "react";
import { Capacitor } from "@capacitor/core";
import "@/App.css";

// Native app cold-start: skip the marketing landing page and go straight to
// the dashboard (if already signed in) or the login screen.
const nativeHome = () => {
  let isNative = false;
  try { isNative = Capacitor.isNativePlatform(); } catch { isNative = false; }
  if (!isNative) return null;
  return localStorage.getItem("fl_token") ? "/app" : "/login";
};import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigationType } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import { MaintenanceProvider, useMaintenance, MaintenanceScreen } from "@/components/Maintenance";
import { NativeBootstrap } from "@/components/NativeBootstrap";
import { ThemeProvider } from "@/lib/theme";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { AppUpdateBanner } from "@/components/AppUpdateBanner";
import Landing from "@/pages/Landing";
import LandingCinematic from "@/pages/LandingCinematic";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import FAQ from "@/pages/FAQ";
import Features from "@/pages/Features";
import PricingPage from "@/pages/PricingPage";
import TimesheetAppNZ from "@/pages/TimesheetAppNZ";
import JobManagementNZ from "@/pages/JobManagementNZ";
import DownloadPage from "@/pages/DownloadPage";
import SsspGeneratorNZ from "@/pages/SsspGeneratorNZ";
import SimproAlternativeNZ from "@/pages/SimproAlternativeNZ";
import CivilConstructionSoftwareNZ from "@/pages/CivilConstructionSoftwareNZ";
import FleetManagementNZ from "@/pages/FleetManagementNZ";
import SafetyManagementNZ from "@/pages/SafetyManagementNZ";
import PayrollSoftwareCivilNZ from "@/pages/PayrollSoftwareCivilNZ";
import PreStartChecklistNZ from "@/pages/PreStartChecklistNZ";
import SeoProductPage from "@/pages/seo/SeoProductPage";
import { TemplatePage, TEMPLATES } from "@/pages/seo/Templates";
import { GuidePage, GUIDES } from "@/pages/seo/Guides";
import RateLibraryNZ from "@/pages/seo/RateLibraryNZ";
import { SEO_PRODUCTS } from "@/pages/seo/seoProducts";
import { CivilHub, CalculatorPage, CALCULATORS } from "@/pages/seo/Calculators";
import NotFound from "@/pages/seo/NotFound";
import XeroTimesheetIntegrationNZ from "@/pages/XeroTimesheetIntegrationNZ";
import { PageViewTracker } from "@/components/PageViewTracker";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AcceptInvite from "@/pages/AcceptInvite";
import SiteSignin from "@/pages/SiteSignin";
import PublicInduction from "@/pages/PublicInduction";
import VideoCall from "@/pages/VideoCall";
import PublicQuote from "@/pages/PublicQuote";
import PublicInvoice from "@/pages/PublicInvoice";
// import CivilLinkApp from "@/pages/civillink/CivilLinkApp"; // hidden — Civil Link moving to its own platform
import PortalLogin from "@/pages/portal/PortalLogin";
import PortalShell from "@/pages/portal/PortalShell";
import PortalJobs from "@/pages/portal/PortalJobs";
import PortalJob from "@/pages/portal/PortalJob";
import DashboardLayout from "@/pages/dashboard/DashboardLayout";
import OverviewV5 from "@/pages/dashboard/OverviewV5";
import SubscriptionLockedPage from "@/components/SubscriptionLockGate";
import Overview from "@/pages/dashboard/OperatingOverview";
import MyProgress from "@/pages/dashboard/MyProgress";
import Timesheets from "@/pages/dashboard/Timesheets";
import Safety from "@/pages/dashboard/Safety";
import MySafety from "@/pages/dashboard/MySafety";
import { OperatingJobs as Jobs, OperatingJobCreate as JobCreate, OperatingJobDetail as JobDetail } from "@/pages/dashboard/OperatingJobs";
import ArchivedJobs from "@/pages/dashboard/ArchivedJobs";
import JobsRedesignPreview from "@/pages/dashboard/jobs-redesign/JobsRedesignPreview";
import ArchivedSSSPs from "@/pages/dashboard/ArchivedSSSPs";
import CrewNeeds from "@/pages/dashboard/CrewNeeds";
import Clients from "@/pages/dashboard/OperatingClients";
import Fleet from "@/pages/dashboard/Fleet";
import FleetAssetProfile from "@/pages/dashboard/FleetAssetProfile";
import FleetVehicleForm from "@/pages/dashboard/FleetVehicleForm";
import FuelPage from "@/pages/dashboard/Fuel";
import LiveTracking from "@/pages/dashboard/LiveTracking";
import Leave from "@/pages/dashboard/Leave";
import Team from "@/pages/dashboard/Team";
import WorkerProfile from "@/pages/dashboard/WorkerProfile";
import Inbox from "@/pages/dashboard/Inbox";
import Payroll from "@/pages/dashboard/Payroll";
import Billing from "@/pages/dashboard/Billing";
import Branding from "@/pages/dashboard/Branding";
import ManualSupplierInvoice from "@/pages/dashboard/ManualSupplierInvoice";
import Invoices from "@/pages/dashboard/Invoices";
import Variations from "@/pages/dashboard/Variations";
import Correspondence from "@/pages/dashboard/Correspondence";
import BusinessProfile from "@/pages/dashboard/BusinessProfile";
import PublicProfile, { PublicProject } from "@/pages/PublicProfile";
import Directory from "@/pages/Directory";
import Quotes from "@/pages/dashboard/Quotes";
import QuoteWorkspace from "@/pages/dashboard/QuoteWorkspace";
import QuoteItemWorkspace from "@/pages/dashboard/QuoteItemWorkspace";
import InvoiceWorkspace from "@/pages/dashboard/InvoiceWorkspace";
import Tenders from "@/pages/dashboard/Tenders";
import TenderWorkspace from "@/pages/dashboard/TenderWorkspace";
import Takeoffs from "@/pages/dashboard/Takeoffs";
import TakeoffWorkspace from "@/pages/dashboard/TakeoffWorkspace";
import OperationsMap from "@/pages/dashboard/OperationsMap";
import CustomerInvoices from "@/pages/dashboard/CustomerInvoices";
import RateLibrary from "@/pages/dashboard/RateLibrary";
import Competencies from "@/pages/dashboard/Competencies";
import Profile from "@/pages/dashboard/Profile";
import CrewDirectory from "@/pages/dashboard/CrewDirectory";
import ToolboxTalks from "@/pages/dashboard/ToolboxTalks";
import { SupplyYardOverview, SupplyYardLoads, SupplyYardProducts, SupplyYardMaterials, SupplyYardStockpiles, SupplyYardDockets } from "@/pages/dashboard/supplyyard/SupplyYard";
import { SupplyYardCustomers } from "@/pages/dashboard/supplyyard/SupplyYardCustomers";
import { SupplyYardProcessing, SupplyYardStockControl } from "@/pages/dashboard/supplyyard/SupplyYardStock";
import { SupplyYardVisits } from "@/pages/dashboard/supplyyard/SupplyYardVisits";
import { SupplyYardVisitWorkspace } from "@/pages/dashboard/supplyyard/SupplyYardVisitWorkspace";
import { SupplyYardLoaderQueue } from "@/pages/dashboard/supplyyard/SupplyYardLoaderQueue";
import { SupplyYardReports, SupplyYardSettings } from "@/pages/dashboard/supplyyard/SupplyYardReports";
import ToolboxDeliver from "@/pages/dashboard/ToolboxDeliver";
import PreStarts from "@/pages/dashboard/PreStarts";
import Chat from "@/pages/dashboard/Chat";
import PlatformAdmin from "@/pages/dashboard/PlatformAdmin";
import SSSPs from "@/pages/dashboard/SSSPs";
import HazardousSubstances from "@/pages/dashboard/HazardousSubstances";
import SiteInductions from "@/pages/dashboard/SiteInductions";
import SiteInductionBuilder from "@/pages/dashboard/SiteInductionBuilder";
import SiteInductionRunner from "@/pages/dashboard/SiteInductionRunner";
import AdminReviews from "@/pages/dashboard/AdminReviews";
import Reviews from "@/pages/Reviews";
import SSSPEditor from "@/pages/dashboard/SSSPEditor";
import CrewPlanner from "@/pages/dashboard/OperatingSchedule";
import ImportData from "@/pages/dashboard/ImportData";
import Forms from "@/pages/dashboard/Forms";
import FormBuilder from "@/pages/dashboard/FormBuilder";
import Gear from "@/pages/dashboard/Gear";
import Materials from "@/pages/dashboard/Materials";
import CompanyDocuments from "@/pages/dashboard/CompanyDocuments";
import MyCompany from "@/pages/dashboard/MyCompany";
import ChargeUpWorkspace from "@/pages/dashboard/ChargeUpWorkspace";
import SupplierMaterialReview from "@/pages/dashboard/SupplierMaterialReview";
import Support from "@/pages/dashboard/Support";
import Changelog from "@/pages/dashboard/Changelog";
import Help from "@/pages/dashboard/Help";
import ProjectManagement from "@/pages/dashboard/ProjectManagement";
import Leaderboard from "@/pages/dashboard/Leaderboard";
import MoodHeatmap from "@/pages/dashboard/MoodHeatmap";
import Suppliers from "@/pages/dashboard/Suppliers";
import QA from "@/pages/dashboard/QA";
import Reports from "@/pages/dashboard/Reports";
import JobBillingReport from "@/pages/dashboard/JobBillingReport";
import SiteInspections from "@/pages/dashboard/SiteInspections";
import Announcements from "@/pages/dashboard/Announcements";
import XeroIntegration from "@/pages/dashboard/XeroIntegration";
import Financials from "@/pages/dashboard/Financials";
import VideoSupport from "@/pages/dashboard/VideoSupport";
import { WaitingRoomPinger } from "@/components/WaitingRoomPinger";
import AdminPreview1 from "@/pages/dashboard/AdminPreview1";
import AdminPreview2 from "@/pages/dashboard/AdminPreview2";
import AdminPreview3 from "@/pages/dashboard/AdminPreview3";
import FieldPreview1 from "@/pages/dashboard/FieldPreview1";
import FieldPreview2 from "@/pages/dashboard/FieldPreview2";
import FieldPreview3 from "@/pages/dashboard/FieldPreview3";
import PendingSync from "@/pages/dashboard/PendingSync";
import RunningSheets from "@/pages/dashboard/RunningSheets";
import TruckerHome from "@/components/TruckerHome";
import TruckingTime from "@/pages/dashboard/TruckingTime";
import TruckDispatch from "@/pages/dashboard/TruckDispatch";
import ContractorInvoices from "@/pages/dashboard/ContractorInvoices";
import Privacy from "@/pages/legal/Privacy";
import Security from "@/pages/legal/Security";
import Terms from "@/pages/legal/Terms";import { OperatingOnboardingStart as OnboardingStart, OperatingOnboardingSession as OnboardingSession } from "@/pages/dashboard/onboarding/OperatingOnboarding";
import { HubShell } from "@/components/HubShell";
import {
  ShieldAlert, ClipboardCheck, Wrench, FileCheck2, HardHat, FlaskConical, ShieldCheck,
  ClipboardList, Receipt, FileSignature, BarChart3, UserCog, Trophy, Heart, Clock, Truck,
  MapPin, Package, Boxes,
} from "lucide-react";
import DeleteAccount from "@/pages/legal/DeleteAccount";

// ── Phase 2 nav refactor: page-level tabbed hubs that reuse existing pages ──
const H_OFFICE = ["super_admin", "admin", "office"];
const H_OFFICE_QS = [...H_OFFICE, "quantity_surveyor"];
const H_OFFICE_FIELD = [...H_OFFICE, "field"];
const H_ALL = ["super_admin", "admin", "office", "field", "mechanic", "quantity_surveyor"];

const SAFETY_TABS = [
  { key: "safety", label: "Safety", Icon: ShieldAlert, roles: H_OFFICE_FIELD, Component: Safety },
  { key: "toolbox", label: "Toolbox", Icon: ClipboardCheck, roles: H_OFFICE_FIELD, Component: ToolboxTalks },
  { key: "prestarts", label: "Pre-Starts", Icon: Wrench, roles: [...H_OFFICE_FIELD, "mechanic"], Component: PreStarts },
  { key: "sssps", label: "SSSPs", Icon: FileCheck2, roles: H_OFFICE_FIELD, Component: SSSPs },
  { key: "site-inductions", label: "Inductions", Icon: HardHat, roles: H_OFFICE_FIELD, Component: SiteInductions },
  { key: "hazardous", label: "HazSub", Icon: FlaskConical, roles: H_OFFICE_FIELD, Component: HazardousSubstances },
  { key: "qa", label: "QA", Icon: ShieldCheck, roles: H_OFFICE_FIELD, Component: QA },
  { key: "inspections", label: "Inspections", Icon: ClipboardList, roles: H_OFFICE_FIELD, Component: SiteInspections },
  { key: "forms", label: "Forms", Icon: ClipboardList, roles: H_OFFICE, Component: Forms },
];
const BILLING_TABS = [
  { key: "customer-invoices", label: "Customer", Icon: Receipt, roles: H_OFFICE_QS, Component: CustomerInvoices },
  { key: "contractor-invoices", label: "Contractor", Icon: FileSignature, roles: H_OFFICE_FIELD, flag: "contractor", Component: ContractorInvoices },
  { key: "invoices", label: "Supplier Bills", Icon: Receipt, roles: H_OFFICE_QS, Component: Invoices },
  { key: "job-billing", label: "Job Billing", Icon: BarChart3, roles: H_OFFICE_QS, Component: JobBillingReport },
];
const TEAM_TABS = [
  { key: "team", label: "Directory", Icon: UserCog, roles: H_OFFICE, Component: Team },
  { key: "leaderboard", label: "This Week", Icon: Trophy, roles: H_OFFICE_FIELD, Component: Leaderboard },
  { key: "mood", label: "Team Pulse", Icon: Heart, roles: H_OFFICE, Component: MoodHeatmap },
];
const TIME_TABS = [
  { key: "timesheets", label: "Timesheets", Icon: Clock, roles: H_OFFICE_FIELD, Component: Timesheets },
  { key: "running-sheets", label: "Running Sheets", Icon: Truck, roles: H_OFFICE_FIELD, flag: "truck_driver", Component: RunningSheets },
];
const PLANT_TABS = [
  { key: "fleet", label: "Fleet", Icon: Truck, roles: H_ALL, Component: Fleet },
  { key: "live-tracking", label: "Live Tracking", Icon: MapPin, roles: H_OFFICE, Component: LiveTracking },
  { key: "gear", label: "Gear", Icon: Package, roles: [...H_OFFICE_FIELD, "mechanic"], Component: Gear },
];

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const maintenance = useMaintenance();
  if (loading) {
    return (
      <SecureEntryScreen />
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (maintenance.active && user.role !== "super_admin") return <MaintenanceScreen message={maintenance.message} />;
  return children;
}

function RequireRole({ role, children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== role) return <Navigate to="/app" replace />;
  return children;
}

function RequireOffice({ children }) {
  // Office-only sections — field workers get bounced back to their home screen.
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "field") return <Navigate to="/app" replace />;
  return children;
}

// Phase 2 nav refactor: office users hitting a legacy leaf URL are forwarded
// into the corresponding hub tab; field workers keep the plain page (their
// mobile drawer / bottom nav / quick-add still point at the old routes).
function HubRedirect({ to, children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user && user.role !== "field") return <Navigate to={to + (loc.search || "")} replace />;
  return children;
}

function PublicPageScroll() {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();
  const page = pathname.replace(/\/+$/, "") || "/";
  const previousPage = useRef(page);

  useLayoutEffect(() => {
    const changed = previousPage.current !== page;
    previousPage.current = page;
    // Private shells own their navigation. Leave history restoration alone.
    if (!changed || navigationType === "POP" ||
        /^\/(app|portal|civil-link|admin-preview[^/]*)(?:\/|$)/.test(page)) return;
    if (hash) {
      // Honour real anchors; leave unresolved hashes to existing page/browser handling.
      let id = hash.slice(1);
      try { id = decodeURIComponent(id); } catch { /* retain the literal fragment */ }
      const target = document.getElementById(id) || document.getElementsByName(id)[0];
      target?.scrollIntoView({ behavior: "instant", block: "start" });
      return;
    }
    // Public wrappers grow with their content; scrolling belongs to the document.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [page, hash, navigationType]);

  return null;
}

function MaterialsRedirect() {
  const location = useLocation();
  return <Navigate to={`/app/materials${location.search}${location.hash}`} replace />;
}

// Deploy detection (banner + version polling) lives in AppUpdateBanner.

function App() {
  useEffect(() => {
    // When the SW notifies us a notification was clicked, deep-link in-app.
    if (!("serviceWorker" in navigator)) return;
    const onMessage = (e) => {
      if (e.data?.type === "fl-navigate" && typeof e.data.url === "string") {
        try {
          const u = new URL(e.data.url, window.location.origin);
          window.history.pushState({}, "", u.pathname + u.search + u.hash);
          window.dispatchEvent(new PopStateEvent("popstate"));
        } catch { /* ignore */ }
      }
    };
    navigator.serviceWorker.addEventListener("message", onMessage);
    return () => navigator.serviceWorker.removeEventListener("message", onMessage);
  }, []);
  return (
    <div className="App">
      <ErrorBoundary>
      <ThemeProvider>
        <AuthProvider>
        <MaintenanceProvider>
        <BrowserRouter>
          <PublicPageScroll />
          <Toaster position="top-right" richColors closeButton />
          <AppUpdateBanner />
          <PageViewTracker />
          <NativeBootstrap />
          <Routes>
            <Route path="/" element={nativeHome() ? <Navigate to={nativeHome()} replace /> : <LandingCinematic />} />
            <Route path="/homepage-cinematic-preview" element={<Navigate to="/" replace />} />
            <Route path="/homepage-classic-preview" element={<Landing archived />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/features" element={<Features />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/delete-account" element={<DeleteAccount />} />
            <Route path="/security" element={<Security />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/terms-of-service" element={<Navigate to="/terms" replace />} />
            <Route path="/timesheet-app-nz" element={<TimesheetAppNZ />} />
            <Route path="/job-management-nz" element={<JobManagementNZ />} />
            <Route path="/sssp-generator-nz" element={<SsspGeneratorNZ />} />
            <Route path="/simpro-alternative-nz" element={<SimproAlternativeNZ />} />
            <Route path="/civil-construction-software-nz" element={<CivilConstructionSoftwareNZ />} />
            <Route path="/fleet-management-nz" element={<FleetManagementNZ />} />
            <Route path="/safety-management-nz" element={<SafetyManagementNZ />} />
            <Route path="/payroll-software-civil-nz" element={<PayrollSoftwareCivilNZ />} />
            <Route path="/pre-start-checklist-app-nz" element={<PreStartChecklistNZ />} />
            <Route path="/xero-timesheet-integration-nz" element={<XeroTimesheetIntegrationNZ />} />
            {Object.values(SEO_PRODUCTS).map((cfg) => (
              <Route key={cfg.path} path={cfg.path} element={<SeoProductPage cfg={cfg} />} />
            ))}
            <Route path="/resources" element={<CivilHub />} />
            {CALCULATORS.map((c) => (
              <Route key={c.slug} path={`/tools/${c.slug}`} element={<CalculatorPage slug={c.slug} />} />
            ))}
            {TEMPLATES.map((t) => (
              <Route key={t.slug} path={`/templates/${t.slug}`} element={<TemplatePage slug={t.slug} />} />
            ))}
            {GUIDES.map((g) => (
              <Route key={g.slug} path={`/guides/${g.slug}`} element={<GuidePage slug={g.slug} />} />
            ))}
            <Route path="/civil-rate-library-nz" element={<RateLibraryNZ />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/download" element={<DownloadPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/accept-invite" element={<AcceptInvite />} />
            <Route path="/site/:token" element={<SiteSignin />} />
            <Route path="/audit/:token" element={<PublicSiteAudit />} />
            <Route path="/induct/:token" element={<PublicInduction />} />
            <Route path="/landfill/intake/:token" element={<DriverIntake />} />
            <Route path="/call/:token" element={<VideoCall />} />
            <Route path="/q/:token" element={<PublicQuote />} />
            <Route path="/i/:token" element={<PublicInvoice />} />
            <Route path="/company/:slug" element={<PublicProfile />} />
            <Route path="/contractors" element={<Directory />} />
            <Route path="/contractors/:service" element={<Directory />} />
            <Route path="/company/:slug/projects/:pslug" element={<PublicProject />} />
            {/* Civil Link route hidden — moving to its own platform
            <Route
              path="/civil-link/*"
              element={
                <ProtectedRoute>
                  <CivilLinkApp />
                </ProtectedRoute>
              }
            /> */}
            <Route path="/portal" element={<PortalLogin />} />
            <Route path="/portal/t/:token" element={<PortalLogin />} />
            <Route path="/portal/jobs" element={<PortalShell />}>
              <Route index element={<PortalJobs />} />
              <Route path=":id" element={<PortalJob />} />
            </Route>
            <Route
              path="/admin-preview-1"
              element={
                <ProtectedRoute>
                  <AdminPreview1 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin-preview-2"
              element={
                <ProtectedRoute>
                  <AdminPreview2 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin-preview-3"
              element={
                <ProtectedRoute>
                  <AdminPreview3 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/field-preview-1"
              element={
                <ProtectedRoute>
                  <FieldPreview1 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/field-preview-2"
              element={
                <ProtectedRoute>
                  <FieldPreview2 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/field-preview-3"
              element={
                <ProtectedRoute>
                  <FieldPreview3 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/app"
              element={
                <ProtectedRoute>
                  <WaitingRoomPinger />
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<OverviewV5 />} />
              <Route path="overview-classic" element={<Overview />} />
              <Route path="dashboard-redesign-preview" element={<Navigate to="/app" replace />} />
              <Route path="health-safety" element={<HealthSafetyWorkspace />}>
                <Route index element={<HealthSafetyOverview />} />
                <Route path="sitewise" element={<SiteWisePreparation />} />
                <Route path="sssps" element={<SSSPs />} />
                <Route path="sssps/:id" element={<SSSPEditor />} />
                <Route path="toolbox-talks" element={<ToolboxTalks />} />
                <Route path="toolbox-talks/:id" element={<ToolboxDeliver />} />
                <Route path="pre-starts" element={<PreStarts />} />
                <Route path="inductions" element={<SiteInductions />} />
                <Route path="inductions/:id" element={<SiteInductionBuilder />} />
                <Route path="inductions/:id/induct" element={<SiteInductionRunner />} />
                <Route path="hazards" element={<Safety />} />
                <Route path="risks" element={<HazardsRisks />} />
                <Route path="hazsub" element={<HazardousSubstances />} />
                <Route path="inspections" element={<SiteInspections />} />
                <Route path="qa" element={<QA />} />
                <Route path="forms" element={<Forms />} />
                <Route path="forms/new" element={<FormBuilder />} />
                <Route path="forms/:id/edit" element={<FormBuilder />} />
                <Route path="competencies" element={<Competencies />} />
                <Route path="documents" element={<CompanyDocuments category="Health & Safety" />} />
              </Route>
              <Route path="my-safety" element={<MySafety />} />
              <Route path="my-safety/:actionId" element={<MySafety />} />
              <Route path="form-work/:assignmentId/:day" element={<AssignedForm />} />
              <Route path="locked" element={<SubscriptionLockedPage />} />
              {/* ── Phase 2 tabbed hubs (reuse existing pages) ── */}
              <Route path="safety-qa" element={<HubShell base="/app/safety-qa" tabs={SAFETY_TABS} />} />
              <Route path="safety-qa/:tab" element={<HubShell base="/app/safety-qa" tabs={SAFETY_TABS} />} />
              <Route path="invoicing/invoices/manual" element={<RequireOffice><ManualSupplierInvoice /></RequireOffice>} />
              <Route path="invoicing" element={<HubShell base="/app/invoicing" tabs={BILLING_TABS} />} />
              <Route path="invoicing/:tab" element={<HubShell base="/app/invoicing" tabs={BILLING_TABS} />} />
              <Route path="team-hub" element={<HubShell base="/app/team-hub" tabs={TEAM_TABS} />} />
              <Route path="team-hub/:tab" element={<HubShell base="/app/team-hub" tabs={TEAM_TABS} />} />
              <Route path="time" element={<HubShell base="/app/time" tabs={TIME_TABS} />} />
              <Route path="time/:tab" element={<HubShell base="/app/time" tabs={TIME_TABS} />} />
              <Route path="plant" element={<HubShell base="/app/plant" tabs={PLANT_TABS} />} />
              <Route path="plant/fleet/:id" element={<FleetAssetProfile />} />
              <Route path="plant/:tab" element={<HubShell base="/app/plant" tabs={PLANT_TABS} />} />
              <Route path="timesheets" element={<HubRedirect to="/app/time/timesheets"><Timesheets /></HubRedirect>} />
              <Route path="safety" element={<HubRedirect to="/app/safety-qa/safety"><Safety /></HubRedirect>} />
              <Route path="toolbox" element={<HubRedirect to="/app/safety-qa/toolbox"><ToolboxTalks /></HubRedirect>} />
              <Route path="my-runs" element={<TruckerHome />} />
              <Route path="trucking-time" element={<TruckingTime />} />
              <Route path="trucking" element={<TruckingWorkspace />}>
                <Route index element={<TruckingOverview />} />
                <Route path="dispatch" element={<TruckDispatch />} />
                <Route path="jobs" element={<TruckingJobs />} />
                <Route path="jobs/new" element={<TruckingJobFormPage />} />
                <Route path="jobs/:id/edit" element={<TruckingJobFormPage />} />
                <Route path="jobs/:id" element={<TruckingJobDetail />} />
                <Route path="running-sheets" element={<RunningSheets />} />
                <Route path="live-tracking" element={<LiveTracking />} />
                <Route path="ready-to-bill" element={<TruckingReadyToBill />} />
                <Route path="trucks" element={<Fleet trucksOnly />} />
                <Route path="reports" element={<TruckingReports />} />
                <Route path="reconciliation" element={<TruckingReconciliation />} />
              </Route>
              <Route path="supply-yard" element={<SupplyYardOverview />} />
              <Route path="supply-yard/visits" element={<SupplyYardVisits />} />
              <Route path="supply-yard/visits/:id" element={<SupplyYardVisitWorkspace />} />
              <Route path="supply-yard/loader-queue" element={<SupplyYardLoaderQueue />} />
              <Route path="supply-yard/inbound" element={<SupplyYardLoads />} />
              <Route path="supply-yard/outbound" element={<SupplyYardLoads />} />
              <Route path="supply-yard/products" element={<SupplyYardProducts />} />
              <Route path="supply-yard/materials" element={<SupplyYardMaterials />} />
              <Route path="supply-yard/stockpiles" element={<SupplyYardStockpiles />} />
              <Route path="supply-yard/processing" element={<SupplyYardProcessing />} />
              <Route path="supply-yard/stock-control" element={<SupplyYardStockControl />} />
              <Route path="supply-yard/customers" element={<SupplyYardCustomers />} />
              <Route path="supply-yard/dockets" element={<SupplyYardDockets />} />
              <Route path="supply-yard/reports" element={<SupplyYardReports />} />
              <Route path="supply-yard/settings" element={<SupplyYardSettings />} />
              <Route path="landfill" element={<LandfillWorkspace />}>
                <Route index element={<LandfillOverview />} />
                <Route path="loads" element={<LandfillLoads />} />
                <Route path="tipsites" element={<LandfillTipsites />} />
                <Route path="companies" element={<LandfillCompanies />} />
                <Route path="invoices" element={<LandfillInvoices />} />
                <Route path="rates" element={<LandfillRates />} />
                <Route path="trucks" element={<LandfillTrucks />} />
              </Route>
              <Route path="toolbox/:id" element={<ToolboxDeliver />} />
              <Route path="prestarts" element={<HubRedirect to="/app/safety-qa/prestarts"><PreStarts /></HubRedirect>} />
              <Route path="chat" element={<Chat />} />
              <Route path="schedule" element={<Navigate to="/app/crew-planner?view=day" replace />} />
              <Route path="platform" element={
                <RequireRole role="super_admin"><PlatformAdmin /></RequireRole>
              } />
              <Route path="jobs" element={<Jobs />} />
              <Route path="jobs/new" element={<JobCreate />} />
              <Route path="jobs/archived" element={<ArchivedJobs />} />
              <Route path="jobs-redesign-preview" element={<JobsRedesignPreview />} />
              <Route path="sssps/archived" element={<ArchivedSSSPs />} />
              <Route path="jobs/:id" element={<JobDetail />} />
              <Route path="jobs/:id/charge-up" element={<ChargeUpWorkspace />} />
              <Route path="jobs/:id/supplier-materials/:invoiceId/review" element={<SupplierMaterialReview />} />
              <Route path="jobs/:id/:tab" element={<JobDetail />} />
              <Route path="crew-needs" element={<CrewNeeds />} />
              <Route path="clients" element={<Clients />} />
              <Route path="clients/:cid" element={<Clients />} />
              <Route path="clients/:cid/properties/:pid" element={<Clients />} />
              <Route path="fleet" element={<HubRedirect to="/app/plant/fleet"><Fleet /></HubRedirect>} />
              <Route path="fleet/new" element={<FleetVehicleForm />} />
              <Route path="fleet/:id/edit" element={<FleetVehicleForm />} />
              <Route path="fuel" element={<FuelPage />} />
              <Route path="live-tracking" element={<HubRedirect to="/app/plant/live-tracking"><LiveTracking /></HubRedirect>} />
              <Route path="leave" element={<Leave />} />
              <Route path="progress" element={<MyProgress />} />
              <Route path="team" element={<HubRedirect to="/app/team-hub/team"><Team /></HubRedirect>} />
              <Route path="team/:id" element={<WorkerProfile />} />
              <Route path="inbox" element={<Inbox />} />
              <Route path="payroll" element={<Payroll />} />
              <Route path="billing" element={<Billing />} />
              <Route path="branding" element={<Branding />} />
              <Route path="invoices" element={<HubRedirect to="/app/invoicing/invoices"><Invoices /></HubRedirect>} />
              <Route path="quotes" element={<Quotes />} />
              <Route path="quotes/new" element={<QuoteWorkspace />} />
              <Route path="quotes/:qid" element={<QuoteWorkspace />} />
              <Route path="quotes/:qid/items" element={<QuoteItemWorkspace />} />
              <Route path="tenders" element={<Tenders />} />
              <Route path="tenders/new" element={<TenderWorkspace />} />
              <Route path="tenders/:id/documents" element={<TenderWorkspace />} />
              <Route path="tenders/:id" element={<TenderWorkspace />} />
              <Route path="takeoffs" element={<Takeoffs />} />
              <Route path="takeoffs/:tid" element={<TakeoffWorkspace />} />
              <Route path="operations-map" element={<OperationsMap />} />
              <Route path="customer-invoices" element={<HubRedirect to="/app/invoicing/customer-invoices"><CustomerInvoices /></HubRedirect>} />
              <Route path="customer-invoices/new" element={<InvoiceWorkspace />} />
              <Route path="customer-invoices/:iid" element={<InvoiceWorkspace />} />
              <Route path="rate-library" element={<RateLibrary />} />
              <Route path="competencies" element={<Competencies />} />
              <Route path="variations" element={<Variations />} />
              <Route path="correspondence" element={<Correspondence />} />
              <Route path="business-profile" element={<BusinessProfile />} />
              <Route path="company-documents" element={<RequireOffice><CompanyDocuments /></RequireOffice>} />
              <Route path="my-company" element={<MyCompany />} />
              <Route path="profile" element={<Profile />} />
              <Route path="crew" element={<CrewDirectory />} />
              <Route path="sssps" element={<HubRedirect to="/app/safety-qa/sssps"><SSSPs /></HubRedirect>} />
              <Route path="safety/hazardous-substances" element={<HubRedirect to="/app/safety-qa/hazardous"><HazardousSubstances /></HubRedirect>} />
              <Route path="safety/site-inductions" element={<HubRedirect to="/app/safety-qa/site-inductions"><SiteInductions /></HubRedirect>} />
              <Route path="safety/site-inductions/:id/induct" element={<SiteInductionRunner />} />
              <Route path="safety/site-inductions/:id" element={<SiteInductionBuilder />} />
              <Route path="admin/reviews" element={<AdminReviews />} />
              <Route path="sssps/:id" element={<SSSPEditor />} />
              <Route path="crew-planner" element={<CrewPlanner />} />
              <Route path="import" element={<ImportData />} />
              {/* Old Job Dispatch — consolidated into Crew Planner's Day Board */}
              <Route path="dispatch" element={<Navigate to="/app/crew-planner?view=day" replace />} />
              <Route path="forms" element={<HubRedirect to="/app/safety-qa/forms"><Forms /></HubRedirect>} />
              <Route path="forms/new" element={<FormBuilder />} />
              <Route path="forms/:id/edit" element={<FormBuilder />} />
              <Route path="sync" element={<PendingSync />} />
              <Route path="running-sheets" element={<HubRedirect to="/app/time/running-sheets"><RunningSheets /></HubRedirect>} />
              <Route path="truck-dispatch" element={<TruckDispatch />} />
              <Route path="contractor-invoices" element={<HubRedirect to="/app/invoicing/contractor-invoices"><ContractorInvoices /></HubRedirect>} />
              <Route path="gear" element={<HubRedirect to="/app/plant/gear"><Gear /></HubRedirect>} />
              <Route path="materials" element={<Materials />} />
              <Route path="plant/materials" element={<MaterialsRedirect />} />
              <Route path="support" element={<Support />} />
              <Route path="changelog" element={<Changelog />} />
              <Route path="help" element={<RequireOffice><Help /></RequireOffice>} />
              <Route path="pm" element={<RequireOffice><ProjectManagement /></RequireOffice>} />
              <Route path="leaderboard" element={<HubRedirect to="/app/team-hub/leaderboard"><Leaderboard /></HubRedirect>} />
              <Route path="mood-heatmap" element={<RequireOffice><HubRedirect to="/app/team-hub/mood"><MoodHeatmap /></HubRedirect></RequireOffice>} />
              <Route path="suppliers" element={<Suppliers />} />
              <Route path="qa" element={<HubRedirect to="/app/safety-qa/qa"><QA /></HubRedirect>} />
              <Route path="inspections" element={<HubRedirect to="/app/safety-qa/inspections"><SiteInspections /></HubRedirect>} />
              <Route path="announcements" element={<Announcements />} />
              <Route path="integrations/xero" element={<XeroIntegration />} />
              <Route path="financials" element={<Financials />} />
              <Route path="video-support" element={
                <RequireRole role="super_admin"><VideoSupport /></RequireRole>
              } />
              <Route path="reports/monthly" element={<Reports />} />
              <Route path="reports/job-billing" element={<JobBillingReport />} />
              <Route path="onboarding" element={<RequireOffice><OnboardingStart /></RequireOffice>} />
              <Route path="onboarding/session/:id" element={<RequireOffice><OnboardingSession /></RequireOffice>} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
        </MaintenanceProvider>
      </AuthProvider>
      </ThemeProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
